import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Tooltip, Spin } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useCourseDetail, useCourseUnitDetail, useProfile } from '../../../../hooks'
import { Watched, VoteLike } from '../../../../components'
import { Wrapper, VoteContainer } from './styled'

const UnitInfo = ({ lesson }) => {
  const { type, unitId } = lesson
  const { courseId } = useParams()
  const { profile } = useProfile()
  const { isLoading, loadCourseUnitDetailAction, courseUnitDetail } = useCourseUnitDetail()
  const [open, setOpen] = useState(false)

  const { voteLikeUnitAction, isLiking } = useCourseDetail({
    userId: profile.userId,
    courseId
  })

  const handleOpenChange = (flag) => {
    setOpen(flag)

    if (flag && (!courseUnitDetail || !courseUnitDetail[unitId])) {
      loadCourseUnitDetailAction({
        courseId,
        courseUnitId: unitId,
        unitType: type
      })
    }
  }

  return (
    <Wrapper>
      <Tooltip
        title={isLoading || !courseUnitDetail || !courseUnitDetail[unitId] ? <Spin size="small" style={{ padding: '0.5rem' }} /> : (
          <VoteContainer>
            <Watched voteNumber={courseUnitDetail[unitId].countOpenLesson} />
            <VoteLike
              isLike={courseUnitDetail[unitId].isLike}
              courseId={courseId}
              courseUnitId={unitId}
              typeUnit={type}
              voteAction={voteLikeUnitAction}
              voteNumber={courseUnitDetail[unitId].countLikeCourse}
              item={courseUnitDetail[unitId]}
              isLiking={isLiking}
            />
          </VoteContainer>
        )}
        open={open}
        onOpenChange={handleOpenChange}
        mouseLeaveDelay={0.5}
        color="#fff"
      >
        <InfoCircleOutlined />
      </Tooltip>
    </Wrapper>
  )
}

UnitInfo.propTypes = {
  lesson: PropTypes.object
}

export default UnitInfo
